import apiClient from './apiClient';

export interface Rank {
  id: string;
  level: number;
  name: string;
  pointsRequired: number;
  iconUrl: string;
}

class RanksService {
  /**
   * Получить все ранги для определенной фракции
   */
  async getRanksByFaction(faction: 'human' | 'alien'): Promise<Rank[]> {
    const response = await apiClient.get<Rank[]>(`/api/ranks/${faction}`);
    return response;
  }


}

export default new RanksService();